<script lang="ts" setup>
import {
  BlockCarouselImageSelectFields,
  BlockCarouselManualFields,
  BlockFooterCTAFields,
  BlockImageCollectionFields,
  BlockImageTextFields,
  BlockPoolNavigationFields,
  BlockPoolUPSFields,
  BlockSingleQuoteFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readItems, $readItem } = useNuxtApp()
const { t } = useI18n()

const route = useRoute()

const { data, error } = await useAsyncData('project_detail', async () => {
  const projects = await $directus.request($readItems('projects', {
    filter: {
      slug: {
        _eq: route.params.slug,
      },
      status: {
        _eq: 'published',
      },
    },
  }))
  if (projects.length === 0) {
    console.error('Project not found')
    throw createError({
      statusCode: 404,
      message: 'no published project with that slug found',
    })
  }

  return await $directus.request($readItem('projects', projects[0].id, {
    fields: [
      'id',
      'slug',
      {
        seo: ['*', {
          translations: ['*'],
        }],
        translations: ['*'],
        hero_image: ['*'],
        hero_video: ['*'],

        blocks: [
          'collection',
          'id',
          {
            item: {
              block_carousel_manual: BlockCarouselManualFields, //
              block_pool_navigation: BlockPoolNavigationFields, //
              block_single_quote: BlockSingleQuoteFields, //
              block_image_text: BlockImageTextFields, //
              block_footer_cta: BlockFooterCTAFields, //
              block_carousel_image_select: BlockCarouselImageSelectFields,
              block_pool_ups: BlockPoolUPSFields,
              // project specific
              block_image_collection: BlockImageCollectionFields,
            },
          },
        ],
      },
    ],
  }))
})

if (error.value) {
  throw createError({
    fatal: true,
    statusCode: 404,
    message: 'Pool not found',
  })
}
useDirectusSEO(data.value?.seo)
</script>

<template>
  <div>
    <HeroDetail
      :data="{
        hero_image: data?.hero_image,
        hero_video: data?.hero_video,
        translations: data?.translations,
      } as any
      "
      :back-button="{
        text: t('general.back_to_overview'),
        link: '/projects',
      }"
    />
    <div>
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockPoolNavigation v-if="block.collection === 'block_pool_navigation'" />
        <BlockSingleQuote v-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockImageText v-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockCarouselManual v-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <!-- Pool Detail Specific -->
        <BlockPoolUPS v-if="block.collection === 'block_pool_ups'" :data="block.item" />
        <BlockPoolVariants v-if="block.collection === 'block_pool_variants'" :specs="data?.tech_specs!" :data="block.item" />
        <BlockPoolPalette v-if="block.collection === 'block_pool_palette'" :data="block.item" />
        <BlockCarouselImageSelect v-if="block.collection === 'block_carousel_image_select'" :data="block.item" />
        <BlockImageCollection v-if="block.collection === 'block_image_collection'" :data="block.item" />
      </div>
      <!-- <pre>{{ data }}</pre> -->
    </div>
  </div>
</template>

<style>

</style>
